module.exports = __webpack_public_path__ + "static/media/salocil_logo.50632a68.svg";